import axiosPrivate from "@services/axiosPrivate";
import { GET_PATIENT_URL } from "src/constants";

export const getPatientByid = (email) => {
  return axiosPrivate.get(`${GET_PATIENT_URL}/?email=${email}`);
};
